import { useNavigate, useParams } from 'react-router-dom';
import { eventService } from 'library/api/eventService';
import { useAppDispatch } from 'library/hooks/common';
import { removeEvent } from 'library/redux/events';
import { openDialogModal, showPopup } from 'library/redux/modal';
import useVisitors from '../common/model';

export const useEventDelete = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { getTicketList } = useVisitors();
  const { code } = useParams<{ code: string }>();

  const remove = async (id: number) => {
    let message = 'Вы успешно удалили мероприятие';
    let messageType: 'success' | 'error' = 'success';
    try {
      dispatch(removeEvent(id));
      const response = await eventService.deleteEvent(id);
      if (response.status !== 204) {
        throw response;
      }
      navigate(`/events/${code}`);
    } catch (e) {
      console.error(e);
      messageType = 'error';
      message = 'Не удалось удалить мероприятие';
    }

    dispatch(showPopup({ type: messageType, text: message }));
  };

  const deleteEvent = async (id: number, deleteFromList: (id: number) => void) => {
    let message =
      'Если вы удалите мероприятие, деньги за купленные билеты будут возвращены клиентам.';
    let ticketsNumber = 0;

    // Проверяем наличие билетов перед удалением
    try {
      const response = await getTicketList(id);
      if (!response.data) {
        throw response;
      }
      ticketsNumber = response.data.count;

      if (ticketsNumber <= 0) {
        message = 'Вы действительно хотите удалить мероприятие?';
      }
    } catch (error) {
      console.error(error);
    }

    dispatch(
      openDialogModal({
        title: 'Удаление мероприятия',
        text: message,
        confirmText: 'Да',
        confirm: () => {
            remove(id);
            deleteFromList(id);
        },
        declineText: 'Нет',
      })
    );
  };

  return {
    deleteEvent,
  };
};
